import React from 'react'

import { PageLayout } from '@components/common/PageLayout'
import { HeadContent } from '@fourthwall/components'

import { Articles } from './components/Articles'
import { Header } from './components/Header'
import { Tiers } from './modules/Tiers'
import { TiersProvider } from './providers/TiersProvider'

export const Perks = () => (
  <TiersProvider>
    <PageLayout>
      <HeadContent title="Perks &amp; tiers" />
      <Header />
      <Tiers />
      <Articles />
    </PageLayout>
  </TiersProvider>
)
